import { render, staticRenderFns } from "./YzCard.vue?vue&type=template&id=d7bde706&scoped=true&lang=pug&"
import script from "./YzCard.vue?vue&type=script&lang=js&"
export * from "./YzCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7bde706",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
